import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Quote } from "lucide-react";
import { Reveal } from "../Reveal";
import { getTestimonials } from "../../lib/api";

export default function TestimonialsPreview() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getTestimonials().then((d) => setItems(d.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section className="relative py-24 md:py-36" data-testid="testimonials-preview">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div className="max-w-2xl">
              <span className="text-xs uppercase tracking-[0.25em] text-gold">In Their Words</span>
              <h2 className="font-serif text-4xl md:text-6xl font-light mt-4 leading-tight text-foreground">
                Trusted by <span className="text-gradient-gold italic">innovators & clinicians.</span>
              </h2>
            </div>
            <Link
              to="/testimonials"
              data-testid="view-all-testimonials"
              className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.12em] text-gold hover:text-gold-light transition-colors"
            >
              View all <ArrowUpRight size={16} />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-gold/15 bg-card p-8 flex flex-col">
                <Quote className="text-gold/40 mb-5" size={34} />
                <p className="font-serif text-xl md:text-2xl text-foreground/90 leading-relaxed italic flex-1">
                  "{t.quote}"
                </p>
                <div className="mt-8 pt-6 border-t border-gold/10">
                  <p className="text-sm font-semibold text-foreground">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.role} · {t.org}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
